import React from "react"
import { Link } from "gatsby"

import Pill from "~components/Pill"
import * as style from "./Endpoints.module.scss"

const Endpoint = ({ endpoint, verb, microcopy }) => {
  const withPill = endpoint.stabilityLevel === "beta"

  return (
    <Link
      to={endpoint.path}
      className={style.link}
      data-verb-pill={withPill}
    >
      <strong data-verb={endpoint.verb}>{verb}</strong>
      <span>{endpoint.title}</span>
      {withPill
          && (
          <Pill
            pillType="pillSmall"
            text={microcopy.text("reference.pill.beta")}
            color="blue"
            className={style.endpointPill}
          />
          )}
    </Link>
  )
}

export default Endpoint
